import styled from 'styled-components'
import { limitLines } from 'src/styles'

export const PostTitle = styled.h2`
  ${limitLines(2)}
`

PostTitle.displayName = 'PostTitle'

export const PostDescription = styled.p`
  ${limitLines(4)}
`

PostDescription.displayName = 'PostDescription'

export const ViewMore = styled.span`
  &:hover {
    text-decoration: underline;
  }
`

ViewMore.displayName = 'ViewMore'

export const MediaWrapper = styled.div`
  width: 102px;
  height: 102px;
`

MediaWrapper.displayName = 'MediaWrapper'
